export const formatContent = (value, unit, dataType) => {
	let formattedText = "";
	switch (dataType) {
		case "currency":
			formattedText = `${unit}${value}`;
			break;
		case "number":
			formattedText = `${value}${unit}`;
			break;
		default:
			formattedText = `${value}${unit}`;
	}
	return formattedText;
};

export const getRule = (rule, unit, dataType) => {
	let value;
	if (rule && rule.Min) {
		value = formatContent(rule.Min, unit, dataType);
		return `Must be more than ${value}`;
	} else if (rule && rule.Max) {
		value = formatContent(rule.Min, unit, dataType);
		return `Must be less than ${value}`;
	}
};
//Remove leading zeros
export const removeLeadingZeros = (number) => {
	return number.replace(/^0+/, '')
};



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/helper.js